module.exports = __webpack_public_path__ + "img/tp-green-cir.2be15f47.svg";